import { Box, CircularProgress } from "@mui/material";
import TimelineDate from "./TimelineDate.tsx";
import { type FC, useCallback, useEffect, useState } from "react";
import * as WorkPacketsAPI from "../../api/workPacketsAPI";
import debounce from "lodash.debounce";
import { type ChangelogDate } from "src/types/work-packets";
import { type WorkPacketType } from "../../WorkPacketType";

interface ChangeLogProps {
  workPacketId: string;
  workPacketType: WorkPacketType,
}

export const ChangeLog: FC<ChangeLogProps> = ({ workPacketId, workPacketType }) => {
  const [changeLogs, setChangeLogs] = useState<ChangelogDate[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const fetchChangeLog = useCallback(
    debounce(
      async () => {
        setLoading(true);
        try {
          const data = await WorkPacketsAPI.fetchChangeLogs(workPacketId, workPacketType);
          setChangeLogs(data);
        } catch (error) {
          console.error("Error in fetchChangeLog:", error);
        } finally {
          setLoading(false);
        }
      },
      300,
      { leading: true, trailing: false }
    ),
    [workPacketId, workPacketType],
  );

  useEffect(() => {
    fetchChangeLog();
  }, [workPacketId]);

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="200px"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      <Box paddingTop="32px">
        {changeLogs.map((dateGroup, index) => (
          <TimelineDate key={index} {...dateGroup} />
        ))}
      </Box>
    </Box>
  );
};
